import React, { Component } from 'react';
import {RangeHistogram, RangeSlider} from 'searchkit';
import RangeInput from './RangeInput';
import {webshop} from './webshop';
import {defaults} from 'lodash';

class RangeComponent extends Component {
  constructor(props) {
    super(props)

    this.onReset = this.onReset.bind(this)
    this.onFinished  = this.onFinished.bind(this)
  }

  onReset(ev) {
    ev.preventDefault();
    this.props.onReset()
  }

  onFinished(values) {
    this.props.onUpdate(values)
  }

  render() {
    const props = this.props;
    const inputProps = defaults({
     onFinished: this.onFinished,
      minValue: props.min,
      maxValue: props.max
    }, props);

    return (<div>
      <RangeHistogram {...props} />
      <RangeSlider {...props} />
      <RangeInput {...inputProps} />
      <div className="ws-price-range-reset">
        <a href="#" onClick={this.onReset}>{webshop.lang.resetPriceFilter}</a>
      </div>
    </div>)
  }
}

export default RangeComponent;



// WEBPACK FOOTER //
// ./src/RangeComponent.js